module.exports = __webpack_public_path__ + "media/images/sp/plans/reason_01_after@3x-9efc4efdedb580c68f904bf47c6825c4.webp";